import type { ProBillingPeriod } from '../types'

export type ProBillingToggleProps = {
  selection: ProBillingPeriod
  monthlyPriceLabel: string
  annualPriceLabel: string
  annualSavingsLabel: string
  onChange: (period: ProBillingPeriod) => void
}

export function ProBillingToggle({
  selection,
  monthlyPriceLabel,
  annualPriceLabel,
  annualSavingsLabel,
  onChange,
}: ProBillingToggleProps) {
  const isMonthly = selection === 'monthly'
  const isAnnual = selection === 'annual'

  return (
    <div className="flex gap-2" data-testid="pro-billing-toggle">
      <button
        type="button"
        data-testid="pro-billing-monthly"
        aria-pressed={isMonthly}
        onClick={() => onChange('monthly')}
        className={`flex-1 rounded-lg border-2 px-3 py-2.5 text-center transition-colors ${
          isMonthly
            ? 'border-primary bg-primary text-primary-foreground'
            : 'border-border bg-card text-foreground hover:border-primary/40'
        }`}
      >
        <span className="block text-sm font-semibold">Monthly</span>
        <span
          className={`mt-0.5 block text-xs ${
            isMonthly ? 'text-primary-foreground/80' : 'text-muted-foreground'
          }`}
        >
          {monthlyPriceLabel}
        </span>
      </button>
      <button
        type="button"
        data-testid="pro-billing-annual"
        aria-pressed={isAnnual}
        onClick={() => onChange('annual')}
        className={`flex-1 rounded-lg border-2 px-3 py-2.5 text-center transition-colors ${
          isAnnual
            ? 'border-primary bg-primary text-primary-foreground'
            : 'border-border bg-card text-foreground hover:border-primary/40'
        }`}
      >
        <div className="flex items-center justify-center gap-2">
          <span className="text-sm font-semibold">Annual</span>
          {annualSavingsLabel === '' ? null : (
            <span
              className={`rounded px-1.5 py-0.5 text-2xs font-bold ${
                isAnnual ? 'bg-black/20 text-primary-foreground' : 'bg-primary/20 text-primary'
              }`}
            >
              {annualSavingsLabel}
            </span>
          )}
        </div>
        <span
          className={`mt-0.5 block text-xs ${
            isAnnual ? 'text-primary-foreground/80' : 'text-muted-foreground'
          }`}
        >
          {annualPriceLabel}
        </span>
      </button>
    </div>
  )
}
